/** API payload value for owner-is-unassigned filter (must stay aligned with backend). */
export const OPPORTUNITY_REPORTING_UNASSIGNED_OWNER_VALUE = '__unassigned';
